import { Modal, useViewport } from '@tryhackme/thm-ui-components';
import { useEffect, useMemo } from 'react';
import { BREAKPOINTS } from 'src/common/constants/breakpoints';
import { useTrackEventMutation } from 'src/common/slices';
import type { SegmentEvent } from 'src/common/types';
import { SignupForm } from 'src/features/signup/components/signup-form/signup-form';
import { useIsRemoveUsernameExperimentEnabled } from '../../hooks';
import type { SignupModalProps } from './signup-modal.types';
export const SignupModal: React.FC<SignupModalProps> = ({
  open,
  initialEmail,
  onOpenChange
}) => {
  const isRemoveUsernameExperimentEnabled = useIsRemoveUsernameExperimentEnabled();
  const {
    width
  } = useViewport();
  const isSmallMobile = width < BREAKPOINTS.SMALL_MOBILE;
  const [trackEvent] = useTrackEventMutation();
  useEffect(() => {
    if (open) {
      // eslint-disable-next-line no-void
      void trackEvent({
        event: 'view-popup' as SegmentEvent,
        properties: {
          name: 'signup'
        }
      });
    }
  }, [open, trackEvent]);
  const padding = useMemo(() => {
    if (isRemoveUsernameExperimentEnabled) {
      return isSmallMobile ? '3.2rem 1.8rem' : '4.6rem';
    }
    return '2.6rem 3rem 3rem';
  }, [isSmallMobile, isRemoveUsernameExperimentEnabled]);
  return <Modal open={open} onOpenChange={onOpenChange} isSmall maxHeight="100%" padding={padding} preventOnOpenAutoFocus data-sentry-element="Modal" data-sentry-component="SignupModal" data-sentry-source-file="signup-modal.tsx">
      <SignupForm initialEmail={initialEmail} onOpenChange={onOpenChange} data-sentry-element="SignupForm" data-sentry-source-file="signup-modal.tsx" />
    </Modal>;
};